// ChoralLiturgicalPanel.jsx
import React from "react";
import EditableField from "./EditableField";

function ChipList({ label, items }) {
  const arr = Array.isArray(items) ? items : [];
  return (
    <div className="ce-field">
      <div className="ce-field__label">{label}</div>
      <div className="ce-field__value">
        {arr.length === 0 ? (
          <span className="ce-field__value--unknown">None recorded</span>
        ) : (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {arr.map((v) => (
              <span
                key={v}
                style={{
                  padding: "2px 10px",
                  borderRadius: 999,
                  background: "var(--li-parchment-warm, #EDE3CB)",
                  fontSize: "0.78rem",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {v}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function ChoralLiturgicalPanel({ work, readOnly = false, onSaved, apiBase }) {
  return (
    <section className="ce-panel" data-testid="ce-liturgical-panel">
      <h3 className="ce-panel__heading">Liturgical Profile</h3>
      <ChipList label="Seasons"   items={work.seasons} />
      <ChipList label="Feasts"    items={work.feasts} />
      <ChipList label="Moments"   items={work.liturgical_moments} />
      <ChipList label="Themes"    items={work.themes} />
      <EditableField
        workId={work.id}
        field="primary_use"
        label="Primary Use"
        value={work.primary_use}
        readOnly={readOnly}
        onSaved={onSaved}
        apiBase={apiBase}
      />
      <EditableField
        workId={work.id}
        field="editorial_classification"
        label="Editorial Class"
        value={work.editorial_classification}
        readOnly={readOnly}
        onSaved={onSaved}
        apiBase={apiBase}
      />
    </section>
  );
}
